// src/components/PendingBuyRequests/PendingBuyRequestsHeader.js

import * as React from 'react';
import { Grid, Box, IconButton, Popover } from "@mui/material";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const InfoTable = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'flex-start', padding:'0.5em' }}>

      <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', margin: '0 0 0.25em 0' }}>
        <div
          className="non-transferrable-language"
          style={{ margin: '0 0.25em 0 0' }}
        >
          NTL
        </div>
        Non-Transferrable Language
      </div>

      <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
        <div
          style={{
            backgroundColor: "#F2D1CF",
            width: '32px',
            height: '14px',
            borderRadius: '4px',
            margin: '0 0.25em 0 0',
          }}
        ></div>
        Obstructed/Limited View
      </div>
    </div>
  );
};



const PendingBuyRequestsHeader = ({ onRefreshClick }) => {

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Grid container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0' }} >
      <Box container sx={{ display: 'flex', alignItems: 'center' }} >
        <p style={{ fontWeight: '600', fontSize: "14px", margin: '0 0.25em 0 0' }}>Pending Buy Requests</p>
        <IconButton aria-describedby={id} variant="contained" onClick={handleClick}>
          <InfoOutlinedIcon color="primary" />
        </IconButton>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <InfoTable />
        </Popover>
      </Box>

      <Grid>
        <IconButton
          size="small"
          variant="outlined"
          color="primary"
          onClick={onRefreshClick}
        >
          <RefreshOutlinedIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default PendingBuyRequestsHeader;
